import { gql } from "@apollo/client";

export const GET_MY_PACKAGES = gql`
  query getMyPackages(
    $include_projects_packages: Boolean
    $include_monthly_packages: Boolean
  ) {
    Offices {
      Package {
        getMyPackages(
          include_projects_packages: $include_projects_packages
          include_monthly_packages: $include_monthly_packages
        ) {
          max_users
          max_boosts
          max_high_pr
          max_web_featured
          adding_user_fees
          name
          description
          sub_pkg_category
          sub_pkg_type
          status
          value
          adding_user_transaction_type
          offer_value
          category_name
          enabled
          new_value
          action
          note
          group_id
          group_en
          group_ar
          monthly_equivalent_pkg_id
          yearly_equivalent_pkg_id
        }
      }
    }
  }
`;

export const GET_PACKAGES = gql`
  query packages(
    $include_projects_packages: Boolean
    $include_monthly_packages: Boolean
  ) {
    Offices {
      packages(
        include_projects_packages: $include_projects_packages
        include_monthly_packages: $include_monthly_packages
      ) {
        max_users
        max_boosts
        max_high_pr
        max_web_featured
        name
        description
        sub_pkg_category
        sub_pkg_type
        category_name
        status
        value
        note
        group_id
        group_en
        group_ar
        monthly_equivalent_pkg_id
        yearly_equivalent_pkg_id
      }
    }
  }
`;

export const GET_MONTHLY_PACKAGES = gql`
  query {
    Offices {
      getMonthlyPackages {
        max_users
        max_boosts
        max_high_pr
        max_web_featured
        name
        description
        sub_pkg_category
        category_name
        sub_pkg_type
        status
        value
        note
      }
    }
  }
`;

export const GET_FEES = gql`
  {
    Offices {
      fees {
        name_ar
        name_en
        description
        transaction_type
        status
        value
        category_name
      }
    }
  }
`;

export const GET_EJAR_FEES = gql`
  {
    Offices {
      Ejar {
        getFees {
          createdAt
          updatedAt
          type_id
          name
          value
          transaction_category
          description
          category_name
        }
      }
    }
  }
`;

export const GET_EJAR_RESIDENTIAL_FEES = gql`
  query getResidentialRentContractFees($contract_id: Int!) {
    Offices {
      Ejar {
        getResidentialRentContractFees(contract_id: $contract_id) {
          createdAt
          updatedAt
          type_id
          name
          value
          transaction_category
          description
          category_name
        }
      }
    }
  }
`;

export const GET_EJAR_COMMERCIAL_FEES = gql`
  query getCommercialRentContractFees($contract_id: Int!) {
    Offices {
      Ejar {
        getCommercialRentContractFees(contract_id: $contract_id) {
          createdAt
          updatedAt
          type_id
          name
          value
          transaction_category
          description
          category_name
        }
      }
    }
  }
`;

export const GET_EJAR_ECRS_FEES = gql`
  query fetchEjarContractPriceByContractId($contract_id: Int!) {
    EjarEcrs {
      fetchEjarContractPriceByContractId(contract_id: $contract_id) {
        price
        transaction_type
        transaction_type_details {
          description
          name
        }
      }
    }
  }
`;

export const GET_CARDS_LIST = gql`
  query {
    User {
      payment_methods_center {
        listCards {
          card_holder_name
          card_type
          card_expiry_date
          card_currency
          card_number
          last_used_time
          default_card
          card_name
          card_cvv_required
        }
      }
    }
  }
`;

export const GET_PAYFORT_DETAILS = gql`
  query payfortDetails($PayfortPayload: String) {
    User {
      payfortDetails(PayfortPayload: $PayfortPayload) {
        payfort_token_url
        payfort_payment_url
        payfort_access_code
        payfort_merchant_identifier
        payfort_req_sha
        payfort_res_sha
        device_public_ip
        encryptedPayfortPayload
        mada_bins
        authorization_transaction_ids
      }
    }
  }
`;
export const MAKE_PAYMENT = gql`
  mutation makePayment(
    $card_number: String!
    $card_expiry_date: String!
    $card_cvv: String
    $payment_info: PaymentInfo
  ) {
    User {
      payment_methods_center {
        makePayment(
          card_number: $card_number
          card_expiry_date: $card_expiry_date
          card_cvv: $card_cvv
          payment_info: $payment_info
        ) {
          success
          response_message
          redirection_url
        }
      }
    }
  }
`;

export const CHANGE_DEFAULT_CARD = gql`
  mutation setDefaultCard($card_number: String!, $card_expiry_date: String!) {
    User {
      payment_methods_center {
        setDefaultCard(
          card_number: $card_number
          card_expiry_date: $card_expiry_date
        )
      }
    }
  }
`;

export const DELETE_CARD = gql`
  mutation deleteCard($card_number: String!, $card_expiry_date: String!) {
    User {
      payment_methods_center {
        deleteCard(
          card_number: $card_number
          card_expiry_date: $card_expiry_date
        )
      }
    }
  }
`;

export const GET_PRICE_WITH_PROMO_CODE = gql`
  query getPriceWithPromoCode(
    $transaction_type_id: Int!
    $promo_code: String!
    $amount: Float!
  ) {
    PromoCodes {
      getPriceWithPromoCode(
        transaction_type_id: $transaction_type_id
        promo_code: $promo_code
        amount: $amount
      ) {
        price_after_discount
        discount_value
      }
    }
  }
`;

export const GET_ADD_USER_FEES = gql`
  query {
    Offices {
      Subscription {
        getAddUserFee
      }
    }
  }
`;

export const GET_ADD_CORPORATE_PACKAGE_FEE = gql`
  query {
    Offices {
      Subscription {
        getAddCorporatePackageFee
      }
    }
  }
`;

export const GET_BOOSTING_OPTIONS = gql`
  query boostingOptions($category: Int!) {
    Listing {
      boostingOptions(category: $category) {
        text
        sub
        ios_product_id
        price
        option
        type_id
      }
    }
  }
`;

export const INIT_PAYMENT = gql`
  mutation initPayment($payload: String) {
    User {
      payment_methods_center {
        initPayment(payload: $payload) {
          price
          merchant_ref_id
        }
      }
    }
  }
`;

export const UPDATE_PAYMENT = gql`
  mutation updatePayment(
    $merchant_ref_id: String!
    $input: UpdatePaymentInput!
  ) {
    User {
      payment_methods_center {
        updatePayment(merchant_ref_id: $merchant_ref_id, input: $input)
      }
    }
  }
`;

export const REFRESH_PAYMENT = gql`
  mutation refreshPayment($merchant_ref_id: String!) {
    User {
      payment_methods_center {
        refreshPayment(merchant_ref_id: $merchant_ref_id) {
          price
          merchant_ref_id
        }
      }
    }
  }
`;

export const GET_PAYFORT_SIGNITURE = gql`
  query getPayfortRequestSignature(
    $AccessCode: String!
    $PayfortRequest: String
  ) {
    User {
      getPayfortRequestSignature(
        AccessCode: $AccessCode
        PayfortRequest: $PayfortRequest
      )
    }
  }
`;

export const GET_UNPAID_ADMIN_FEES = gql`
  query {
    User {
      getUnpaidAdminFees {
        id
        amount
        note
      }
    }
  }
`;
